import React, { useEffect, useRef, useState } from 'react';
import { createSlider } from '../../../utils/commonfunction';
import Skeleton from 'react-loading-skeleton'
import { FeaturedOutlets } from '../services/website.services';
import { useTranslation } from 'react-i18next';



const WebsiteFeaturedOutlet = ({ id = "featuredSlider" }) => {

    const [featuredOutletData, setFeaturedOutletData] = useState([]);
    const [apiLoaded, setApiLoaded] = useState(false);
    const FeaturedOutletSliderRef = useRef();
    const { t } = useTranslation();


    useEffect(() => {
        FeaturedOutlets().then((response) => {
            setApiLoaded(true);
            setFeaturedOutletData(response?.data?.list || []);
        }).catch((err) => {
            console.log("err", err);
        })
    }, []);

    useEffect(() => {
        if (FeaturedOutletSliderRef?.current) {
            createSlider(`#${id}`, {
                loop: true,
                margin: 20,
                nav: true,
                dots: false,
                responsive: {
                    0: {
                        items: 1
                    },
                    600: {
                        items: 3
                    },
                    1000: {
                        items: 4
                    }
                }
            });
        }
    }, [FeaturedOutletSliderRef, apiLoaded]);

    return (
        <>
            {apiLoaded ?
                featuredOutletData && featuredOutletData.length ?
                    <section className="featured-outlets-sec section-padding pt-0">
                        <div className="container">
                            <div className="heading-section d-flex align-items-center flex-column gap-3 mb-5">
                                <h4>{t("website.home.web_featured_outlets")}</h4>
                            </div>
                            <>
                          {featuredOutletData ?
                                <div className="owl-carousel owl-theme enable-nav-flex" id={id} ref={FeaturedOutletSliderRef}>
                                    {featuredOutletData && featuredOutletData.map((item, index) => (
                                        <div className="item" key={index}>
                                            <div className="outlets-box">
                                                <figure>
                                                    <img src={item?.cafe_logo} alt={item?.cafe_name} className="img-fluid" />
                                                </figure>
                                                <figcaption>
                                                    <h4>{item?.cafe_name}</h4>
                                                    <p className="d-flex gap-2 align-items-center"><i className="ti ti-map-pin"></i>{item?.address}</p>
                                                </figcaption>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                                : null}
                                </>
                        </div>
                    </section>
                    : null
                :
                <section className="featured-restaurants-section section-padding-top">
                    <div className="container" style={{ minHeight: '351.8px' }}>
                        <div className="row">
                            <div className="col-lg-3 col-md-4 ">
                                <Skeleton className='rounded-4' height={200} />
                            </div>
                            <div className="col-lg-3 col-md-4  d-none d-md-block">
                                <Skeleton className='rounded-4' height={200} />
                            </div>
                            <div className="col-lg-3 col-md-4  d-none d-md-block">
                                <Skeleton className='rounded-4' height={200} />
                            </div>
                            <div className="col-lg-3 col-md-4  d-none d-lg-block">
                                <Skeleton className='rounded-4' height={200} />
                            </div>
                        </div>
                    </div>
                </section>
            }

        </>
    )
}

export default WebsiteFeaturedOutlet
